import { autoinject } from "aurelia-dependency-injection";
import { bindable } from "aurelia-templating";

type ColorTheme = 'primary' | 'sustainability';
const mobileFiltersWidthDelimeter: number = 1024; //Screen width above which mobile filters are hidden

//Load styles
require("./comp-mobile-filters.scss");

@autoinject()
export class CompMobileFilters {

    // Determines if a filter is currently selected or not
    public filterSelected: boolean;

    // Contains the currently selected filter's content
    public filterSelectedContent: HTMLElement;

    // Contains all the mobile filters' html content
    public compMobileFilters: HTMLElement;

    public showFilters: boolean;

    // Determines whether the filters are within MEP sections in the platform
    @bindable()
    public theme: ColorTheme = 'primary';

    @bindable()
    public opensInsideDialog: boolean;

    constructor() { }

    attached() {
        // Show mobile filters using css transition after component has been attached to DOM
        setTimeout(() => {
            this.showFilters = true;
        }, 5);

        window.addEventListener('resize', this.checkWidth);
    }

    checkWidth = () => {
        if (window.innerWidth >= mobileFiltersWidthDelimeter)
            this.resetProperties();
    }

    resetProperties = () => {
        this.showFilters = false;
        this.filterSelected = false;
        this.filterSelectedContent.innerHTML = "";
    }

    detached() {
        this.resetProperties();

        window.removeEventListener('resize', this.checkWidth);
    }

    /**
     * Mobile filter selected event handler
     * @param $event
     */
    mobileFilterSelectedHandler($event) {
        this.filterSelected = true;
        this.filterSelectedContent.innerHTML = "";
        // Set filterSelectedContent's html to selected filter's html
        this.filterSelectedContent.appendChild($event.detail);
    }

    /**
     * Close the 'filterSelected' section
     */
    closeSelectedMobileFilter(event: Event) {
        event.stopPropagation();

        const filterElementBody = this.compMobileFilters.getElementsByClassName('slot-content-wrapper')[0].children[0].children[0];
        const closeFilterEvent = new CustomEvent('close-filter', { bubbles: true });
        filterElementBody.dispatchEvent(closeFilterEvent);

        this.filterSelected = false;
        this.filterSelectedContent.innerHTML = "";
    }

    /**
     * Raise 'hide-filters' event
     */
    closeFilters(event: Event) {
        event.stopPropagation();

        this.showFilters = false;

        // Reset filter selected
        this.filterSelected = false;

        // Wait for css transition to close mobile filters
        setTimeout(() => {
            const event = new CustomEvent('hide-filters', { bubbles: true });
            this.compMobileFilters.dispatchEvent(event);
        }, 300);
    }

    /**
     * Raise 'apply-all-filters' event
     */
    applyAllFilters(event: Event) {
        this.stopEventPropagation(event);

        // Hide filters (after which filters will be applied)
        this.showFilters = false;

        // Reset filter selected
        this.filterSelected = false;

        // Delay event, to allow time for close filters animation
        setTimeout(() => {
            const customEvent = new CustomEvent('apply-all-filters', { bubbles: true });
            this.compMobileFilters.dispatchEvent(customEvent);
        }, 300);
    }

    /**
     * Raise 'apply-selected-filters' event
     */
    applySelectedFilters(event: Event) {
        this.stopEventPropagation(event);

        // Dispatch event within filter markup itself
        const filterElementBody = this.compMobileFilters.getElementsByClassName('slot-content-wrapper')[0].children[0].children[0];
        const customFilterSelectedEvent = new CustomEvent('apply-selected-filter', { bubbles: true, cancelable: true });
        //should return true if filter is applied/is valid
        const applyFilter = filterElementBody.dispatchEvent(customFilterSelectedEvent);
        //if its valid it will call apply in the view where we apply the filter
        if(applyFilter) {
            // Go back to showing all filters
            this.filterSelected = false;
            const customEvent = new CustomEvent('apply-selected-filters', { bubbles: true });
            this.compMobileFilters.dispatchEvent(customEvent);
        }
    }

    /**
     * Raise 'clear-all-filters' event
     */
    clearAllFilters() {
        const event = new CustomEvent('clear-all-filters', { bubbles: true });
        this.compMobileFilters.dispatchEvent(event);
    }

    /**
     * Stop bubbling events caused by clicks on the component
     * Click event propagation may affect other components that listen to document clicks i.e. entity-finder-search-filter
     * @param $event
     */
    stopEventPropagation($event: Event) {
        $event.stopPropagation();
    }
}
